"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _axios = _interopRequireDefault(require("axios"));

var _Switcher = _interopRequireDefault(require("@insided/deprecated-preact-components/control/Switcher"));

var _LabelText = _interopRequireDefault(require("@insided/shared/uikit/LabelText"));

var _NavigationHeader = _interopRequireDefault(require("@insided/deprecated-control/menu/NavigationHeader"));

var _common = require("@insided/shared/utils/common");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _PanelItems = require("@insided/deprecated-control/registration-rules/PanelItems");

var _categoryService = require("@insided/control/modules/Categories/categoryService");

var _CategorySelection = _interopRequireDefault(require("@insided/destination/modules/Navigation/shared/CategorySelection"));

var _categories = require("@insided/shared/utils/categories");

var _logger = require("@insided/shared/services/logger");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var titles = {
  aiFeaturesForCM: 'AI Features for Community Managers',
  suggestAiTags: 'Tag Assist',
  aiSearchSummary: 'Search Summary',
  askAISearchSummary: 'AI Answers',
  searchRevamp: 'Enhanced Search Experience',
  searchRevampForAllRoles: 'Enhanced Search Experience for all users',
  aiSmartSearchBeta: 'Smart Search [Closed Beta]',
  askAISearchSummaryBeta: 'AI Answers [Closed Beta]',
  aiSmartSearchEnableForAllRoles: 'Search Summaries for all users',
  onDemandTranslations: 'AI Translations',
  replyBotEnabled: 'Smart Response',
  replyBotBeta: 'Smart Response Beta',
  askAISearchSummaryForNewUsers: 'AI Answers'
};
var sourceTypeLabels = {
  community: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "nav.title.community"
  }),
  zendesk: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "federated.search.zendesk"
  }),
  salesforce: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "federated.search.salesforce"
  }),
  skilljar: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "federated.search.skilljar"
  }),
  freshdesk: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "federated.search.freshdesk"
  }),
  federated: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "federated.search.federated"
  })
};
var moduleLabels = {
  community: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "nav.title.community"
  }),
  knowledge_base: (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "advanced.search.filter.knowledgebase.category"
  }),
  groups: 'Groups',
  ideation: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "topic.form.type.idea.label"
  }),
  product_updates: (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "topic.form.type.product.updates.label"
  })
};

var extractLabel = function extractLabel(key) {
  if (key in sourceTypeLabels) {
    return sourceTypeLabels[key];
  }

  if (key in moduleLabels) {
    return moduleLabels[key];
  }

  return key;
};

var AI_PROVIDER_OPTIONS = [{
  value: 'openai',
  label: 'OpenAI'
}, {
  value: 'gemini',
  label: 'Google Gemini'
}];

var AISettings = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AISettings, _Component);

  var _super = _createSuper(AISettings);

  function AISettings() {
    var _this$props$aiProvide, _this$props$replyBot, _this$props$replyBot2;

    var _this;

    (0, _classCallCheck2.default)(this, AISettings);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      features: {
        aiFeaturesForCM: _common.common.isModuleActive('aiFeaturesForCM'),
        suggestAiTags: _common.common.isModuleActive('suggestAiTags'),
        aiSearchSummary: _common.common.isModuleActive('aiSearchSummary'),
        askAISearchSummary: _common.common.isModuleActive('askAISearchSummary'),
        askAISearchSummaryForNewUsers: _common.common.isModuleActive('askAISearchSummaryForNewUsers'),
        searchRevamp: _common.common.isModuleActive('searchRevamp'),
        aiSmartSearchBeta: _common.common.isModuleActive('aiSmartSearchBeta'),
        askAISearchSummaryBeta: _common.common.isModuleActive('askAISearchSummaryBeta'),
        aiSmartSearchEnableForAllRoles: _common.common.isModuleActive('aiSmartSearchEnableForAllRoles'),
        searchRevampForAllRoles: _common.common.isModuleActive('searchRevampForAllRoles'),
        onDemandTranslations: _common.common.isModuleActive('onDemandTranslations'),
        replyBotEnabled: _common.common.isModuleActive('replyBotEnabled'),
        replyBotBeta: _common.common.isModuleActive('replyBotBeta')
      },
      companyName: _this.props.companyName,
      communityContext: _this.props.communityContext,
      aiProvider: (_this$props$aiProvide = _this.props.aiProvider) !== null && _this$props$aiProvide !== void 0 ? _this$props$aiProvide : 'openai',
      showHeader: false,
      showAlert: false,
      alertType: null,
      alertMessage: null,
      alertVisibleFor: null,
      selectedSources: ((_this$props$replyBot = _this.props.replyBot) === null || _this$props$replyBot === void 0 ? void 0 : _this$props$replyBot.dataSources) || [],
      selectedCategories: [],
      // Will be populated after loading categories
      closeOnDropdownClick: false,
      initialSelectedSources: ((_this$props$replyBot2 = _this.props.replyBot) === null || _this$props$replyBot2 === void 0 ? void 0 : _this$props$replyBot2.dataSources) || [],
      initialSelectedCategories: [],
      // Will be populated after loading categories
      categoriesLoading: true,
      categoriesV2: {}
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleSourceSelection", function (id, checked) {
      _this.setState(function (prevState) {
        var selectedSources = prevState.selectedSources;
        var sourceId = String(id);
        return {
          selectedSources: checked ? [].concat((0, _toConsumableArray2.default)(selectedSources), [sourceId]) : selectedSources.filter(function (s) {
            return s !== sourceId;
          }),
          closeOnDropdownClick: false
        };
      }, function () {
        // Reset closeOnDropdownClick after state update
        setTimeout(function () {
          _this.setState({
            closeOnDropdownClick: true
          });
        }, 0);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCategorySelectionChange", function (selectedCategories) {
      _this.setState({
        selectedCategories: selectedCategories
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDropdownCollapse", function (_id) {
      // This is called when expanding/collapsing nested items in the dropdown
      // We don't need to track dropdown open state here
      _this.setState({
        closeOnDropdownClick: false
      }, function () {
        // Reset closeOnDropdownClick after state update
        setTimeout(function () {
          _this.setState({
            closeOnDropdownClick: true
          });
        }, 0);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSelectedSourcesLabel", function () {
      var selectedSources = _this.state.selectedSources;

      if (selectedSources.length === 0) {
        return 'Select sources';
      }

      if (selectedSources.length === 1) {
        var source = selectedSources[0];

        if (source.includes('community:')) {
          var moduleKey = source.split(':')[1];
          return extractLabel(moduleKey);
        }

        return extractLabel(source);
      }

      return "".concat(selectedSources.length, " sources selected");
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onToggleFeature", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(feature, enabled) {
        var features;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                features = _this.state.features;
                _context.next = 3;
                return _axios.default.post('/aiFeatures/save', {
                  module: feature,
                  enable: features[feature]
                }).then(function () {
                  _this.setState({
                    showAlert: true,
                    alertType: 'success',
                    alertMessage: "".concat(titles[feature], " has been ").concat(enabled ? 'enabled' : 'disabled', " successfully"),
                    alertVisibleFor: 5000
                  });
                }).catch(function () {
                  return _this.setState(function (_ref2) {
                    var features = _ref2.features;
                    return {
                      showAlert: true,
                      alertType: 'error',
                      alertMessage: null,
                      features: Object.assign(features, (0, _defineProperty2.default)({}, feature, !features[feature]))
                    };
                  });
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveCommunityContext", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value, key, paramName) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _axios.default.post('/aiFeatures/saveCommunityParam', {
                  config: (0, _defineProperty2.default)({}, key, value)
                });

              case 3:
                _this.setState({
                  showAlert: true,
                  alertType: 'success',
                  alertMessage: "".concat(paramName, " has been updated successfully"),
                  alertVisibleFor: 5000
                });

                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);

                _logger.logger.error(_context2.t0, {
                  component: 'AISettings',
                  action: 'saveCommunityContext'
                });

                _this.setState({
                  showAlert: true,
                  alertType: 'error',
                  alertMessage: 'Something went wrong!'
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }));

      return function (_x3, _x4, _x5) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCompanyNameChange", function (e) {
      _this.saveCommunityContext(e.target.value, 'companyName', 'Company name');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCommunityContextChange", function (e) {
      _this.saveCommunityContext(e.target.value, 'communityContext', 'Community context');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAiProviderChange", function (value) {
      _this.setState({
        aiProvider: value
      }, function () {
        _this.saveCommunityContext(value, 'aiProvider', 'AI Model Provider');
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadCategories", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$props$replyBot3, types, categoriesV2, savedCategoryIds, selectedCategories, flattenedCategories;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              types = [0]; // Community type
              // Add groups type (4) if groups are enabled

              if (_common.common.isModuleActive('group')) {
                types.push(4);
              }

              _context3.next = 5;
              return (0, _categoryService.getCategoriesList)(types);

            case 5:
              categoriesV2 = _context3.sent;
              // Convert saved category IDs to NormalisedCategoryStructure objects
              savedCategoryIds = ((_this$props$replyBot3 = _this.props.replyBot) === null || _this$props$replyBot3 === void 0 ? void 0 : _this$props$replyBot3.categories) || [];
              selectedCategories = [];

              if (savedCategoryIds.length > 0 && Object.keys(categoriesV2).length > 0) {
                flattenedCategories = (0, _categories.flattenCategoryList)((0, _categories.getMergedCategoryList)(categoriesV2));
                savedCategoryIds.forEach(function (categoryId) {
                  var category = flattenedCategories.find(function (cat) {
                    return cat.id === String(categoryId);
                  });

                  if (category) {
                    selectedCategories.push(category);
                  }
                });
              }

              _this.setState({
                categoriesV2: categoriesV2,
                selectedCategories: selectedCategories,
                initialSelectedCategories: [].concat(selectedCategories),
                categoriesLoading: false
              });

              _context3.next = 16;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](0);

              _logger.logger.error(_context3.t0, {
                component: 'AISettings',
                action: 'loadCategories'
              });

              _this.setState({
                categoriesLoading: false,
                showAlert: true,
                alertType: 'error',
                alertMessage: 'Failed to load categories'
              });

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveReplyBotSources", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this$state, selectedSources, selectedCategories, categoryIds;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$state = _this.state, selectedSources = _this$state.selectedSources, selectedCategories = _this$state.selectedCategories; // Validate that at least one source is selected when enabling the feature

              if (!(selectedSources.length === 0)) {
                _context4.next = 4;
                break;
              }

              _this.setState({
                showAlert: true,
                alertType: 'error',
                alertMessage: 'Please select at least one content source',
                alertVisibleFor: 5000
              });

              return _context4.abrupt("return");

            case 4:
              _context4.prev = 4;
              // Save the complete replyBot object with both sources and categories
              categoryIds = selectedCategories.map(function (cat) {
                return Number(cat.id);
              });
              _context4.next = 8;
              return _this.saveCommunityContext({
                dataSources: selectedSources,
                categories: categoryIds
              }, 'replyBot', 'Smart Response content sources');

            case 8:
              // Update initial state tracking after successful save
              _this.setState({
                initialSelectedSources: (0, _toConsumableArray2.default)(selectedSources)
              });

              _context4.next = 15;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);

              _logger.logger.error(_context4.t0, {
                component: 'AISettings',
                action: 'saveReplyBotSources'
              });

              _this.setState({
                showAlert: true,
                alertType: 'error',
                alertMessage: 'Failed to save Smart Response content sources'
              });

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 11]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cancelReplyBotSources", function () {
      var initialSelectedSources = _this.state.initialSelectedSources;

      _this.setState({
        selectedSources: (0, _toConsumableArray2.default)(initialSelectedSources)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasReplyBotSourcesChanges", function () {
      var _this$state2 = _this.state,
          selectedSources = _this$state2.selectedSources,
          initialSelectedSources = _this$state2.initialSelectedSources;
      return JSON.stringify(selectedSources.sort()) !== JSON.stringify(initialSelectedSources.sort());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveReplyBotCategories", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var _this$state3, selectedCategories, selectedSources, categoryIds;

      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$state3 = _this.state, selectedCategories = _this$state3.selectedCategories, selectedSources = _this$state3.selectedSources;
              _context5.prev = 1;
              // Save the complete replyBot object with both sources and categories
              categoryIds = selectedCategories.map(function (cat) {
                return Number(cat.id);
              });
              _context5.next = 5;
              return _this.saveCommunityContext({
                dataSources: selectedSources,
                categories: categoryIds
              }, 'replyBot', 'Smart Response categories');

            case 5:
              // Update initial state tracking after successful save
              _this.setState({
                initialSelectedCategories: (0, _toConsumableArray2.default)(selectedCategories)
              });

              _context5.next = 12;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);

              _logger.logger.error(_context5.t0, {
                component: 'AISettings',
                action: 'saveReplyBotCategories'
              });

              _this.setState({
                showAlert: true,
                alertType: 'error',
                alertMessage: 'Failed to save Smart Response categories'
              });

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cancelReplyBotCategories", function () {
      var initialSelectedCategories = _this.state.initialSelectedCategories;

      _this.setState({
        selectedCategories: (0, _toConsumableArray2.default)(initialSelectedCategories)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasReplyBotCategoriesChanges", function () {
      var _this$state4 = _this.state,
          selectedCategories = _this$state4.selectedCategories,
          initialSelectedCategories = _this$state4.initialSelectedCategories;
      var selectedIds = selectedCategories.map(function (cat) {
        return cat.id;
      }).sort(function (a, b) {
        return Number(a) - Number(b);
      });
      var initialIds = initialSelectedCategories.map(function (cat) {
        return cat.id;
      }).sort(function (a, b) {
        return Number(a) - Number(b);
      });
      return JSON.stringify(selectedIds) !== JSON.stringify(initialIds);
    });
    return _this;
  }

  (0, _createClass2.default)(AISettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          showHeader: true
        });
      }, 0);
      this.loadCategories();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _AI_PROVIDER_OPTIONS$,
          _AI_PROVIDER_OPTIONS$2;

      var _this$state5 = this.state,
          features = _this$state5.features,
          showAlert = _this$state5.showAlert,
          alertType = _this$state5.alertType,
          alertMessage = _this$state5.alertMessage,
          alertVisibleFor = _this$state5.alertVisibleFor,
          showHeader = _this$state5.showHeader,
          companyName = _this$state5.companyName,
          communityContext = _this$state5.communityContext,
          aiProvider = _this$state5.aiProvider,
          selectedSources = _this$state5.selectedSources,
          selectedCategories = _this$state5.selectedCategories,
          closeOnDropdownClick = _this$state5.closeOnDropdownClick,
          categoriesLoading = _this$state5.categoriesLoading,
          categoriesV2 = _this$state5.categoriesV2;
      return (0, _preact.h)("div", {
        className: "ai-features community-configuration-page"
      }, showHeader && (0, _preact.h)(_NavigationHeader.default, {
        title: "AI"
      }), showAlert && (0, _preact.h)(_AlertComponent.default, {
        messageType: alertType,
        message: alertMessage,
        isVisibleFor: alertVisibleFor,
        sticky: true,
        renderHTML: true,
        onTimeoutEnd: function onTimeoutEnd() {
          return _this3.setState({
            showAlert: false
          });
        }
      }), (0, _preact.h)("label", {
        className: "section-title"
      }, "General Settings"), (0, _preact.h)("div", {
        className: "general-settings-container"
      }, (0, _preact.h)(_InputGroup.default, {
        newStyle: true,
        title: "Company name",
        value: companyName,
        onChange: this.onCompanyNameChange,
        onInput: function onInput(e) {
          _this3.setState({
            companyName: e.target.value
          });
        }
      }), (0, _preact.h)("div", {
        className: (0, _classnames.default)('community-context', 'form-group', 'form-group--new-style')
      }, (0, _preact.h)("label", {
        className: "community-context-label"
      }, (0, _preact.h)("span", {
        className: "community-context-title"
      }, "Community context"), (0, _preact.h)("span", {
        className: "char-count-down"
      }, 1000 - communityContext.length, " characters left")), (0, _preact.h)("textarea", {
        className: "community-context-textarea form-control",
        maxLength: 1000,
        value: communityContext,
        onInput: function onInput(e) {
          _this3.setState({
            communityContext: e.target.value
          });
        },
        onChange: this.onCommunityContextChange,
        placeholder: "Our community is called EmailMonkey Community. We're dedicated to empowering businesses of all sizes to unlock their full marketing potential through effective email automation and targeted campaigns. Our platform offers intuitive design tools, robust analytics, and seamless integrations with e-commerce and CRM systems to enhance your marketing efforts.\nThis community is a hub for EmailMonkey users to share insights, discuss best practices, and explore innovative strategies for email marketing. Our community is here to support our customers, prospect and marketing enthusiasts in general in maximizing engagement and driving growth through smarter email solutions. Our tone of voice is casual and playful."
      }), (0, _preact.h)("div", {
        className: "community-context-info-line"
      }, "Enter details about your community, goals, product and users to tailor the AI features to your specific community, products, users and goals."))), (0, _preact.h)("label", {
        className: "section-title"
      }, "AI Models"), (0, _preact.h)(_InputGroup.default, {
        newStyle: true,
        title: "Pick a model",
        customInput: (0, _preact.h)(_DropdownControl.default, {
          closeOnDropdownClick: true,
          align: "left",
          triggerClass: "ai-model-provider-dropdown",
          items: AI_PROVIDER_OPTIONS.map(function (opt) {
            return {
              title: opt.label,
              onClick: function onClick() {
                return _this3.onAiProviderChange(opt.value);
              }
            };
          }),
          trigger: (0, _preact.h)(_Button.default, {
            className: aiProvider ? 'selected' : 'default',
            title: (_AI_PROVIDER_OPTIONS$ = (_AI_PROVIDER_OPTIONS$2 = AI_PROVIDER_OPTIONS.find(function (o) {
              return o.value === aiProvider;
            })) === null || _AI_PROVIDER_OPTIONS$2 === void 0 ? void 0 : _AI_PROVIDER_OPTIONS$2.label) !== null && _AI_PROVIDER_OPTIONS$ !== void 0 ? _AI_PROVIDER_OPTIONS$ : 'OpenAI',
            endIcon: "chevronDown"
          })
        })
      }), (0, _preact.h)("label", {
        className: "section-title"
      }, "Features"), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch ai-email-generator-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: titles.aiFeaturesForCM,
          description: (0, _preact.h)("div", null, (0, _preact.h)("ul", null, (0, _preact.h)("li", null, "Write with AI: Easily write community content or email campaigns with generative AI. Look for the AI icon next time you're drafting community content or email campaigns in Control."), (0, _preact.h)("li", null, "Community Recap: Introduces a new card on Control Home which will give you a summary of the (max. 10) items unread by team, to help you better identify what's being discussed."), (0, _preact.h)("li", null, "Topic Summary: Quickly grasp the main points of a topic by generating concise summaries.")))
        }),
        on: features.aiFeaturesForCM,
        onChange: function onChange() {
          _this3.setState({
            features: Object.assign(features, {
              aiFeaturesForCM: !features.aiFeaturesForCM
            })
          }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
            return _regenerator.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this3.onToggleFeature('aiFeaturesForCM', features.aiFeaturesForCM);

                  case 2:
                    return _context6.abrupt("return", _context6.sent);

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          })));
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch ai-on-demand-translations-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: titles.onDemandTranslations,
          description: (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Allow community members to instantly translate topics and replies into their preferred language with AI-powered translations. Eliminate language barriers and drive global participation without adding extra work for your team."), (0, _preact.h)("p", null, "Note: Want to enable this for your community? Please contact your Gainsight Account Manager."))
        }),
        on: features.onDemandTranslations,
        onChange: function onChange() {
          _this3.setState({
            features: Object.assign(features, {
              onDemandTranslations: !features.onDemandTranslations
            })
          }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
            return _regenerator.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return _this3.onToggleFeature('onDemandTranslations', features.onDemandTranslations);

                  case 2:
                    return _context7.abrupt("return", _context7.sent);

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          })));
        },
        disable: true
      }), features.replyBotBeta ? (0, _preact.h)("div", null, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch ai-reply-bot-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: titles.replyBotEnabled,
          description: (0, _preact.h)("div", null, (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Enable AI-powered automated responses to help community members get instant answers to common questions.")))
        }),
        on: features.replyBotEnabled,
        onChange: function onChange() {
          _this3.setState({
            features: Object.assign(features, {
              replyBotEnabled: !features.replyBotEnabled
            })
          }, function () {
            _this3.onToggleFeature('replyBotEnabled', features.replyBotEnabled);
          });
        }
      }), (0, _preact.h)("div", {
        className: "reply-bot-sources-container"
      }, features.replyBotEnabled && (0, _preact.h)("div", null, (0, _preact.h)("label", null, "Select content sources for AI responses:"), (0, _preact.h)("div", {
        className: "sources-actions-row"
      }, (0, _preact.h)("div", {
        className: "sources-dropdown-wrapper"
      }, (0, _preact.h)(_dropdown.default, {
        closeOnDropdownClick: closeOnDropdownClick,
        popupName: "reply-bot-sources-selector",
        className: "dropdown-selector reply-bot-sources-selector",
        disabled: !features.replyBotEnabled,
        trigger: (0, _preact.h)("button", {
          type: "button",
          className: "reply-bot-sources-trigger"
        }, (0, _preact.h)("span", null, this.getSelectedSourcesLabel())),
        triggerClass: "reply-bot-sources-trigger-wrapper"
      }, (0, _preact.h)(_NestedDropdown.default, {
        labelId: "reply-bot-sources",
        items: AISettings.buildDropdownItems(),
        onMultiSelect: this.toggleSourceSelection,
        onToggleCollapse: this.toggleDropdownCollapse,
        depth: 2,
        selectedItems: selectedSources
      }))), (0, _preact.h)("div", {
        className: !this.hasReplyBotSourcesChanges() ? 'disabled' : '',
        style: {
          pointerEvents: !this.hasReplyBotSourcesChanges() ? 'none' : 'auto',
          opacity: !this.hasReplyBotSourcesChanges() ? 0.5 : 1
        }
      }, (0, _preact.h)(_PanelItems.ActionButtons, {
        onSave: this.saveReplyBotSources,
        onCancel: this.cancelReplyBotSources
      }))), (0, _preact.h)("div", {
        className: "categories-selection-wrapper",
        style: {
          marginTop: '20px'
        }
      }, (0, _preact.h)("div", {
        className: "categories-content-container",
        style: {
          pointerEvents: categoriesLoading ? 'none' : 'auto',
          opacity: categoriesLoading ? 0.5 : 1
        }
      }, (0, _preact.h)(_CategorySelection.default, {
        categoriesV2: categoriesV2,
        selectedCategories: selectedCategories,
        onChangeSend: this.onCategorySelectionChange,
        label: "Select categories to enable Smart Response for:",
        placeholder: selectedCategories.length > 0 ? "".concat(selectedCategories.length, " ").concat(selectedCategories.length === 1 ? 'category' : 'categories', " selected") : 'Search for categories'
      }), (0, _preact.h)("div", {
        className: (0, _classnames.default)('categories-action-buttons', {
          disabled: !this.hasReplyBotCategoriesChanges()
        }),
        style: {
          pointerEvents: !this.hasReplyBotCategoriesChanges() ? 'none' : 'auto',
          opacity: !this.hasReplyBotCategoriesChanges() ? 0.5 : 1
        }
      }, (0, _preact.h)(_PanelItems.ActionButtons, {
        onSave: this.saveReplyBotCategories,
        onCancel: this.cancelReplyBotCategories
      }))))))) : null, !features.askAISearchSummaryForNewUsers && features.aiSmartSearchBeta ? (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch ai-tag-assist-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: titles.aiSearchSummary,
          description: (0, _preact.h)("div", null, (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Improve how end users search and consume information in community."), (0, _preact.h)("p", null, "Leverage AI summaries that help end users benefit from faster, more efficient information discovery, ensuring instant answers to search queries without endless scrolling of search results")), features.aiSearchSummary && features.askAISearchSummaryBeta ? (0, _preact.h)(_Switcher.default, {
            customClass: "panel-switch ask-ai-search-summary-switch",
            labelCustomClass: "panel-switch-label",
            label: (0, _preact.h)(_LabelText.default, {
              label: titles.askAISearchSummary,
              description: (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Enable AI-powered instant answers with fast streaming responses and an improved user interface. Registered users get direct AI-generated responses to their search queries in real-time, eliminating the need to browse through multiple results."))
            }),
            on: features.askAISearchSummary,
            onChange: function onChange() {
              _this3.setState({
                features: Object.assign(features, {
                  askAISearchSummary: !features.askAISearchSummary
                })
              }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
                return _regenerator.default.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.next = 2;
                        return _this3.onToggleFeature('askAISearchSummary', features.askAISearchSummary);

                      case 2:
                        return _context8.abrupt("return", _context8.sent);

                      case 3:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              })));
            }
          }) : null, features.aiSearchSummary && features.searchRevampForAllRoles ? (0, _preact.h)(_Switcher.default, {
            customClass: "panel-switch search-summary-all-roles-switch",
            labelCustomClass: "panel-switch-label",
            label: (0, _preact.h)(_LabelText.default, {
              label: titles.aiSmartSearchEnableForAllRoles,
              description: (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Enables guest users to leverage AI summaries for faster and efficient information discovery to the search queries"))
            }),
            on: features.aiSmartSearchEnableForAllRoles,
            onChange: function onChange() {
              _this3.setState({
                features: Object.assign(features, {
                  aiSmartSearchEnableForAllRoles: !features.aiSmartSearchEnableForAllRoles
                })
              }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
                return _regenerator.default.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return _this3.onToggleFeature('aiSmartSearchEnableForAllRoles', features.aiSmartSearchEnableForAllRoles);

                      case 2:
                        return _context9.abrupt("return", _context9.sent);

                      case 3:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              })));
            }
          }) : null)
        }),
        on: features.aiSearchSummary,
        onChange: function onChange() {
          _this3.setState({
            features: Object.assign(features, {
              aiSearchSummary: !features.aiSearchSummary
            })
          }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
            return _regenerator.default.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return _this3.onToggleFeature('aiSearchSummary', features.aiSearchSummary);

                  case 2:
                    return _context10.abrupt("return", _context10.sent);

                  case 3:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10);
          })));
        }
      }) : null, features.askAISearchSummaryForNewUsers ? (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch ai-tag-assist-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: titles.askAISearchSummary,
          description: (0, _preact.h)("div", null, (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Enable AI-powered instant answers with fast streaming responses and an improved user interface. Registered users get direct AI-generated responses to their search queries in real-time, eliminating the need to browse through multiple results.")), features.askAISearchSummary && features.searchRevampForAllRoles ? (0, _preact.h)(_Switcher.default, {
            customClass: "panel-switch search-summary-all-roles-switch",
            labelCustomClass: "panel-switch-label",
            label: (0, _preact.h)(_LabelText.default, {
              label: "AI Answers for guest users",
              description: (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Enables guest users to leverage AI Answers for faster and efficient information discovery to the search queries"))
            }),
            on: features.aiSmartSearchEnableForAllRoles,
            onChange: function onChange() {
              _this3.setState({
                features: Object.assign(features, {
                  aiSmartSearchEnableForAllRoles: !features.aiSmartSearchEnableForAllRoles
                })
              }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
                return _regenerator.default.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return _this3.onToggleFeature('aiSmartSearchEnableForAllRoles', features.aiSmartSearchEnableForAllRoles);

                      case 2:
                        return _context11.abrupt("return", _context11.sent);

                      case 3:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11);
              })));
            }
          }) : null)
        }),
        on: features.askAISearchSummary,
        onChange: function onChange() {
          var isEnabling = !features.askAISearchSummary;
          var updatedFeatures = {
            askAISearchSummary: isEnabling,
            // Sync child toggle with parent toggle state
            aiSmartSearchEnableForAllRoles: isEnabling
          };

          _this3.setState({
            features: Object.assign(features, updatedFeatures)
          }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
            return _regenerator.default.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return _this3.onToggleFeature('askAISearchSummary', features.askAISearchSummary);

                  case 2:
                    _context12.next = 4;
                    return _this3.onToggleFeature('aiSmartSearchEnableForAllRoles', isEnabling);

                  case 4:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12);
          })));
        }
      }) : null);
    }
  }], [{
    key: "getAvailableSources",
    value: function getAvailableSources() {
      var sources = []; // Community is always available if the module is active

      sources.push('community'); // Check for federated search sources

      if (_common.common.isModuleActive('freshdeskV2')) {
        sources.push('freshdesk');
      }

      if (_common.common.isModuleActive('zendeskFederatedSearch')) {
        sources.push('zendesk');
      }

      if (_common.common.isModuleActive('salesforceCrm')) {
        sources.push('salesforce');
      }

      if (_common.common.isModuleActive('skilljarFederatedSearch')) {
        sources.push('skilljar');
      }

      return sources;
    }
  }, {
    key: "getAvailableModules",
    value: function getAvailableModules() {
      var modules = [];

      if (_common.common.isModuleActive('knowledgeBase')) {
        modules.push('knowledge_base');
      }

      modules.push('community');

      if (_common.common.isModuleActive('group')) {
        modules.push('groups');
      }

      if (_common.common.isModuleActive('ideationV2')) {
        modules.push('ideation');
      }

      if (_common.common.isModuleActive('productUpdates')) {
        modules.push('product_updates');
      }

      return modules;
    }
  }, {
    key: "buildDropdownItems",
    value: function buildDropdownItems() {
      return AISettings.getAvailableSources().map(function (source) {
        return {
          id: source,
          title: extractLabel(source),
          isCollapsed: source === 'community' ? false : undefined,
          children: source === 'community' ? AISettings.getAvailableModules().map(function (module) {
            return {
              id: "community:".concat(module),
              title: extractLabel(module),
              children: []
            };
          }) : []
        };
      });
    }
  }]);
  return AISettings;
}(_preact.Component);

var _default = AISettings;
exports.default = _default;